<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12">
        <v-row>
          <v-col cols="2">
            <v-btn text @click="$router.go(-1)">
              <v-icon>mdi-arrow-left</v-icon>
              Volver
            </v-btn>
          </v-col>
          <v-col cols="8">
            <v-skeleton-loader v-if="fetchLoading" type="card"></v-skeleton-loader>
            <personal-info-card-component v-else-if="personal" :personal="personal"></personal-info-card-component>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="8">
        <v-skeleton-loader v-if="fetchLoading" type="card"></v-skeleton-loader>
        <v-card v-else-if="personal" class="modern-card ui-module-card ui-module-fade-in-up actualiza-estatus-shell" flat>
          <v-card-title class="modern-title ui-module-titlebar">Actualiza estatus de personal</v-card-title>
          <v-card-text align="center">
            <v-container>
              <v-row align="center">
                <v-col cols="6">
                  <v-text-field
                    :value="personal.CatEstatus.title"
                    rounded
                    filled
                    dense
                    label="Estatus actual"
                    readonly
                    class="modern-input"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-select
                    rounded
                    filled
                    dense
                    item-text="title"
                    v-model="selectedEstatus"
                    :rules="required"
                    :items="estatusPersonal"
                    class="modern-select"
                  >
                    <template v-slot:label>Nuevo estatus <span class="required-asterisk">*</span> </template>
                  </v-select>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions class="justify-center ui-module-actions">
            <v-btn color="error" text class="px-8 mx-4 mb-4" v-on:click="$router.go(-1)">Cancelar</v-btn>
            <v-btn
              class="px-8 mx-4 mb-4"
              color="secondary"
              :loading="loading"
              v-on:click="triggerUpdateEstatus()"
              :disabled="!selectedEstatus || loading"
              >Editar estatus</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import PersonalInfoCardComponent from '../../components/PersonalInfoCardComponent.vue'
import { circularProgressProps } from '../../components/props/props'
import Notificacion from '@/modules/notificaciones/domain/Notificacion'
import { NotificationFactory, NOTIFICATION_TYPES } from '@/modules/notificaciones/domain/NotificationFactory'

export default {
  components: {
    PersonalInfoCardComponent,
  },

  props: {
    id: {
      type: Number,
    },
  },

  async mounted() {
    this.fetchLoading = true
    await Promise.all([this.fetchPersonalById(this.id), this.fetchEstatusPersonal()])
    this.fetchLoading = false
  },

  data() {
    return {
      loading: false,
      fetchLoading: false,
      circularProgressProps,
      activeStep: 1,
      asignaSedePersonalForm: false,
      asignaPuestoPersonalForm: false,
      selectedSede: null,
      selectedSubsede: null,
      selectedPuesto: null,
      selectedEstatus: null,
      selectedDependencia: null,
      required: [(v) => !!v || 'Este campo es requerido.'],
    }
  },

  computed: {
    ...mapGetters('personal', { personal: 'getPersonalSingle' }),
    ...mapGetters('estatusPersonal', { estatusPersonal: 'getEstatusPersonal' }),

  },

  methods: {
    ...mapActions('personal', ['updateEstatusPersonal', 'fetchPersonalById']),
    ...mapActions('estatusPersonal', ['fetchEstatusPersonal']),
    ...mapActions('notificaciones', ['createNotification']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),

    getFullName(persona) {
      if (!persona) return ''
      return [persona.nombre, persona.segundoNombre, persona.apaterno, persona.amaterno].filter(Boolean).join(' ')
    },

    async triggerUpdateEstatus() {
      this.loading = true

      this.personal.fk_idEstatus = this.estatusPersonal.find(({ title }) => title === this.selectedEstatus).id

      await this.updateEstatusPersonal(this.personal)
      await this.sendNotificacion()

      this.loading = false
      this.$router.push('/recursos_humanos/personal')
    },

    async sendNotificacion() {
      try {
        const nombreResponsable = localStorage.getItem('nombre') || 'Usuario'
        const nombreElemento = this.getFullName(this.personal)

        let mensaje = ''
        if (this.selectedEstatus === 'ACTIVO' || (this.selectedEstatus && this.selectedEstatus.title === 'ACTIVO')) {
          mensaje = `El elemento ${nombreResponsable} dio de alta al elemento ${nombreElemento}.`
        } else if (
          this.selectedEstatus === 'BAJA DEFINITIVA' ||
          (this.selectedEstatus && this.selectedEstatus.title === 'BAJA DEFINITIVA')
        ) {
          mensaje = `El elemento ${nombreResponsable} dio de baja al elemento ${nombreElemento}.`
        }

        if (!mensaje) return

        const notification = new NotificationFactory(Notificacion).createNotification(
          NOTIFICATION_TYPES.CAMBIO_ESTATUS,
          {
            responsable: Number(localStorage.getItem('idPersonal')),
            afectado: this.personal.idPersonal,
            mensaje,
          }
        )

        await this.createNotification(notification)
      } catch {
        this.SET_SNACKBAR_MESSAGE('Ocurrió un error al enviar la notificación.')
      }
    },
  },
}
</script>

<style scoped>
/* Modern Card with Glass-morphism */
.modern-card {
  background: rgba(26, 38, 46, 0.6) !important;
  backdrop-filter: blur(10px) !important;
  -webkit-backdrop-filter: blur(10px) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.2) !important;
  border-radius: 20px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3) !important;
  transition: all 0.3s ease !important;
}

/* Modern Title */
.modern-title {
  padding: 20px 24px !important;
  background: rgba(0, 0, 0, 0.15) !important;
  border-bottom: 1px solid rgba(var(--v-secondary-base-rgb), 0.2) !important;
  font-size: 1.5rem !important;
  font-weight: 700 !important;
  text-align: center !important;
  color: #e0e0e0 !important;
}

/* Input fields */
::v-deep .modern-input.v-text-field--filled > .v-input__control > .v-input__slot {
  background: rgba(0, 0, 0, 0.3) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.2) !important;
  border-radius: 12px !important;
  transition: all 0.3s ease !important;
}

::v-deep .modern-input.v-text-field--filled:hover > .v-input__control > .v-input__slot {
  border-color: rgba(var(--v-secondary-base-rgb), 0.4) !important;
  background: rgba(0, 0, 0, 0.4) !important;
}

::v-deep .modern-input.v-input--is-focused.v-text-field--filled > .v-input__control > .v-input__slot {
  border-color: var(--v-secondary-base) !important;
  box-shadow: 0 0 0 2px rgba(var(--v-secondary-base-rgb), 0.15) !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

::v-deep .modern-input .v-text-field__slot input {
  color: #e0e0e0 !important;
}

::v-deep .modern-input .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .modern-input.v-input--is-focused .v-label {
  color: var(--v-secondary-base) !important;
}

::v-deep .modern-input .v-icon {
  color: rgba(var(--v-secondary-base-rgb), 0.7) !important;
}

/* Select fields */
::v-deep .modern-select.v-text-field--filled > .v-input__control > .v-input__slot {
  background: rgba(0, 0, 0, 0.3) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.2) !important;
  border-radius: 12px !important;
  transition: all 0.3s ease !important;
}

::v-deep .modern-select.v-text-field--filled:hover > .v-input__control > .v-input__slot {
  border-color: rgba(var(--v-secondary-base-rgb), 0.4) !important;
  background: rgba(0, 0, 0, 0.4) !important;
}

::v-deep .modern-select.v-input--is-focused.v-text-field--filled > .v-input__control > .v-input__slot {
  border-color: var(--v-secondary-base) !important;
  box-shadow: 0 0 0 2px rgba(var(--v-secondary-base-rgb), 0.15) !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

::v-deep .modern-select .v-select__selection {
  color: #e0e0e0 !important;
}

::v-deep .modern-select .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .modern-select.v-input--is-focused .v-label {
  color: var(--v-secondary-base) !important;
}

::v-deep .modern-select .v-icon {
  color: rgba(var(--v-secondary-base-rgb), 0.7) !important;
}

::v-deep .modern-select.v-input--is-focused .v-icon {
  color: var(--v-secondary-base) !important;
}

/* Required Asterisk */
.required-asterisk {
  color: #fc5c65 !important;
  font-weight: bold !important;
}

/* Botones modernos */
::v-deep .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative !important;
  overflow: hidden !important;
}

::v-deep .v-btn:hover:not(:disabled):not(.v-btn--text) {
  transform: translateY(-2px) !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.6) !important;
}

::v-deep .v-btn.secondary:not(.v-btn--text) {
  background: linear-gradient(135deg, var(--v-secondary-base) 0%, var(--v-secondary-lighten1) 100%) !important;
  color: #ffffff !important;
  box-shadow: 0 4px 16px rgba(var(--v-secondary-base-rgb), 0.4) !important;
}

::v-deep .v-btn.error:not(.v-btn--text) {
  background: linear-gradient(135deg, #fc5c65 0%, #eb3b5a 100%) !important;
  color: #ffffff !important;
  box-shadow: 0 4px 16px rgba(252, 92, 101, 0.4) !important;
}

::v-deep .v-btn--text {
  background: transparent !important;
  color: #e0e0e0 !important;
}

::v-deep .v-btn--text:hover {
  background: rgba(var(--v-secondary-base-rgb), 0.1) !important;
}

::v-deep .v-btn .v-icon {
  transition: all 0.3s ease !important;
  color: inherit !important;
}

::v-deep .v-btn:hover .v-icon {
  transform: scale(1.1) !important;
}

/* List Items (for select menu) */
::v-deep .v-list {
  background: rgba(26, 38, 46, 0.95) !important;
  backdrop-filter: blur(10px);
  border-radius: 12px;
}

::v-deep .v-list-item {
  border-radius: 8px;
  margin: 4px 8px;
  transition: all 0.3s ease;
}

::v-deep .v-list-item:hover {
  background: rgba(var(--v-secondary-base-rgb), 0.15) !important;
}

::v-deep .v-list-item__title,
::v-deep .v-list-item__subtitle {
  color: #e0e0e0 !important;
}

/* Textos generales */
.text-caption,
.text-subtitle-1 {
  color: #e0e0e0 !important;
}

.font-weight-bold {
  font-weight: 700 !important;
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(var(--v-secondary-base-rgb), 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(var(--v-secondary-base-rgb), 0.6);
}

.actualiza-estatus-shell {
  min-height: auto;
}

::v-deep .actualiza-estatus-shell.v-card {
  background: rgba(20, 30, 38, 0.42) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb), 0.22) !important;
  box-shadow: 0 14px 36px rgba(0, 0, 0, 0.38) !important;
  backdrop-filter: blur(8px) !important;
  -webkit-backdrop-filter: blur(8px) !important;
}

::v-deep .actualiza-estatus-shell.v-card:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 18px 42px rgba(0, 0, 0, 0.45) !important;
}
</style>
